module.exports = __webpack_public_path__ + "officialStatic/img/small7.ebc64a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/small7.png
// module id = LxFa
// module chunks = 0